import {
  getDistrictListApi,
  getMunicipalityListApi,
  getWardListApi,
  getCanteenTypeListApi,
  getCanteenListApi,
} from "../../services/canteenService";

import {
  setLoading,
  setError,
  setDistricts,
  setMunicipalities,
  setWards,
  setCanteenTypes,
  setCanteens,
} from "./canteenSlices";

export const loadInitialData = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));

    const results = await Promise.allSettled([
      getDistrictListApi(),
      getCanteenTypeListApi(),
    ]);

    const districtResult = results[0];
    if (districtResult.status === "fulfilled") {
      dispatch(setDistricts(districtResult.value.data || []));
    } else {
      dispatch(setDistricts([]));
      dispatch(setError("Failed to load districts"));
    }

    const typeResult = results[1];
    if (typeResult.status === "fulfilled") {
      dispatch(setCanteenTypes(typeResult.value.data || []));
    } else {
      dispatch(setCanteenTypes([]));
      dispatch(setError("Failed to load canteen types"));
    }
  } catch (error) {
    dispatch(setError("Failed to load initial data"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const loadMunicipalities = (districtId) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    const response = await getMunicipalityListApi(districtId);
    dispatch(setMunicipalities(response.data || []));
  } catch (error) {
    dispatch(setMunicipalities([]));
    dispatch(setError("Failed to load municipalities"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const loadWards = (municipalityId) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    const response = await getWardListApi(municipalityId);
    dispatch(setWards(response.data || []));
  } catch (error) {
    dispatch(setWards([]));
    dispatch(setError("Failed to load wards"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const loadCanteens = (payload) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));
    const response = await getCanteenListApi(payload);
    dispatch(setCanteens(response.data || []));
  } catch (error) {
    dispatch(setCanteens([]));
    dispatch(setError("Failed to load canteens"));
  } finally {
    dispatch(setLoading(false));
  }
};

